import { East, West } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import failedImg from "../../../assets/images/cross-mark.png";

const PaymentFailed = ({ handleContinue, handleTryAgain }) => {
  return (
    <Stack
      className="bg-[#FFFFFF] w-full h-[80vh] py-4 px-5"
      sx={{ padding: "15px" }}
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      spacing={3}
    >
      <img src={failedImg} width={100} loading="lazy" />
      <h1 className="text-4xl my-3 font-['Poppins-Medium']">Oh No!</h1>
      <h1 className="text-lg font-[400] my-3 font-['Poppins-Medium']">
        Payment Failed
      </h1>
      <div className="flex gap-3">
        <Button
          onClick={handleContinue}
          startIcon={<West className="text-[#2F80ED]" />}
          variant="outlined"
          className="border-[#2F80ED] py-2 px-4 text-[#2F80ED] normal-case font-['Poppins-Medium'] min-w-[120px]"
        >
          Do Later
        </Button>
        <Button
          onClick={handleTryAgain}
          className="bg-[#2F80ED] py-2 px-4 text-white normal-case font-['Poppins-Medium'] min-w-[120px]"
        >
          Try Again
        </Button>
      </div>
    </Stack>
  );
};

export default PaymentFailed;
